import { BaseUserProfile, IMarketingAnalyticsProvider } from 'fitbeat.models';

interface IFacebookProviderConfig {
  facebookPixelId?: string;
  facebookConversionsAPIKey?: string;
}

export class FacebookProvider implements IMarketingAnalyticsProvider {
  public readonly name = 'Facebook Analytics';

  constructor(
    private config: IFacebookProviderConfig,
    private logger: any,
    private createShaHash: (data: any) => string,
    private fetch: any) {}

  public async logEvent(name: string, userProfile: BaseUserProfile, data?: any): Promise<void> {
    this.logger.info(`log event ${name} in facebook conversion api`);
    const pixelId = this.config.facebookPixelId;
    const facebookConversionAPIKey = this.config.facebookConversionsAPIKey;

    const envConfigured = pixelId && facebookConversionAPIKey;
    if (!envConfigured) {
      return;
    }

    const url = `https://graph.facebook.com/v14.0/${pixelId}/events?access_token=${facebookConversionAPIKey}`;

    const { firstname, lastname } = userProfile;
    const postBody = {
      data: [{
        event_name: name,
        custom_data: data,
        event_time: Math.floor(Date.now() / 1000),
        action_source: 'other',
        user_data: {
          em: this.createShaHash(userProfile.email),
          ...(firstname ? { fn: this.createShaHash(firstname) } : {}),
          ...(lastname ? { ln: this.createShaHash(lastname) } : {}),
        },
      }],
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postBody),
    };
    const res = await this.fetch(url, options);
    if (!res.ok) {
      throw new Error(`Failed to log tracking event in ${this.name} provider`);
    }
  }

  public async syncCustomer(userProfile: BaseUserProfile): Promise<void> {
    this.logger.debug(`syncCustomer not implemented on the facebook analytics provider`);
  }
}
